import styled from 'styled-components';

export const FloatWidgetWrapper = styled.div`
  padding: 8px 8px 0 8px;
  width: 100%;
  height: 100%;
`;
